import { BiteLogOloPayKioskEvent } from './bite_log_olo_pay_kiosk_event.js';

export function name(event: BiteLogOloPayKioskEvent): string {
  switch (event) {
    case BiteLogOloPayKioskEvent.PaymentDeprecated:
      return 'payment';
    case BiteLogOloPayKioskEvent.PaymentErrorDeprecated:
      return 'payment-error';
    case BiteLogOloPayKioskEvent.RefundDeprecated:
      return 'refund';
    case BiteLogOloPayKioskEvent.RefundErrorDeprecated:
      return 'refund-error';
    case BiteLogOloPayKioskEvent.TerminalDisconnected:
      return 'terminal-disconnected';
  }
}
